import React from "react";
import { SchoolIcon, HomeIcon, CheckIcon, BoxIcon } from "lucide-react";
interface UseCase {
  id: string;
  icon: BoxIcon;
  title: string;
  copy: string;
  points: string[];
}
const useCases: UseCase[] = [{
  id: 'teachers',
  icon: SchoolIcon,
  title: 'For Teachers',
  copy: 'Choose grade-level activities, print them, and use them for class practice, learning centres, or independent work.',
  points: ['Grades 1–5', 'Answer keys included']
}, {
  id: 'families',
  icon: HomeIcon,
  title: 'For Families',
  copy: 'Make at-home math practice easier to start with visual challenges children can complete one page at a time.',
  points: ['Printable at home', 'Clear next steps']
}];
export function BuiltForBoth() {
  return <section className="border-t border-white/10 bg-navy-800" data-id="element-49" data-mp="2jerekbqq6cz9">
      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 py-14 sm:px-6 sm:py-20" data-id="element-50" data-mp="lo6oqwkb947e">
        <h2 className="max-w-xl text-2xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-51" data-mp="hmcsd0h5emd1">
          One Resource. Two Everyday Uses.
        </h2>

        <ul className="mt-9 grid gap-5 sm:grid-cols-2" data-id="element-52" data-mp="3lp1l4nnca421">
          {useCases.map(({
          id,
          icon: Icon,
          title,
          copy,
          points
        }) => <li key={id} className="flex flex-col border border-white/10 bg-navy-700 p-6" data-id="element-53" data-mp="3cqpwus9y3icr">
              <span className="flex h-11 w-11 items-center justify-center border-2 border-brand-cyan/60 bg-navy-900 text-brand-cyan" aria-hidden="true" data-id="element-54" data-mp="3gqi0qroe90bs">
                <Icon className="h-5 w-5" strokeWidth={2.25} data-id="element-55" data-mp="8dst3nih38rq" />
              </span>
              <h3 className="mt-5 text-lg font-bold text-white sm:text-xl" data-id="element-56" data-mp="d9rldm6x9axf">
                {title}
              </h3>
              <p className="mt-2.5 text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-57" data-mp="3vmpqe7ikmtyg">
                {copy}
              </p>
              <ul className="mt-auto flex flex-wrap gap-2 pt-6" data-id="element-58" data-mp="r9sqxey4t6j8">
                {points.map(point => <li key={point} className="flex items-center gap-1.5 border border-brand-emerald/40 bg-brand-emerald/10 px-2.5 py-1 text-xs font-semibold text-brand-emerald" data-id="element-59" data-mp="w0smafrlrgjm">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-60" data-mp="15uoo2doszlnf" />
                    {point}
                  </li>)}
              </ul>
            </li>)}
        </ul>
      </div>
    </section>;
}